import React, {FunctionComponent, useContext, useEffect, useState, useRef} from 'react';
import _ from 'lodash';
import {Context} from '../../../../../store/context';
import {TEMPLATE_DEFAULT} from '../../../../../store/constants';
import {convertToHtml} from '../../../../../utils/email';
import {ChannelParam} from "../../../../../store/QueryParamsStore/QueryParamsEnums";
import { getNodeIdFromPkidOrId } from '../../../../../utils/nodeDestinationUtils';
import nodesStore from '../../../../../store/NodesStore/NodesStore';

interface IEmailContent {
    emailInput: string,
    setEmailInput: (val: string) => void;
    setEmailContent: (content: string) => void;
}

const EmailContent: FunctionComponent<IEmailContent> = ({emailInput, setEmailInput, setEmailContent}) => {
    const {buildingsStore, queryParamsStore, emailTemplatesStore, linksStore} = useContext(Context);
    const {queryParams} = queryParamsStore;
    const {emailTemplates} = emailTemplatesStore;
    const {building, buildingLogo} = buildingsStore;
    const {link} = linksStore;

    const [template, setTemplate] = useState<string | null>(null);
    const contentRef = useRef<any>(null);

    useEffect(() => {
        if(!queryParams) return;
        const templateFilter = {
            buildingId: queryParams.buildingId,
            languageIETF: queryParams.routeLang,
            type: 'photoRoute',
        };
        const templateFound = _.get(
            _.find(emailTemplates, templateFilter),
            'template', null
        );
        const template = _.isEmpty(templateFound) ? TEMPLATE_DEFAULT : templateFound;
        setTemplate(template);
    }, [queryParams, emailTemplates]);

    useEffect(() => {
        if(!contentRef.current) return;
        setEmailContent(contentRef.current.innerHTML);
    }, [contentRef.current])

    const renderEmailTemplate = () => {
        if(!building || !link) return null;

        const linkWithEmailChannel = new URL('', link);
        linkWithEmailChannel.searchParams.set('channel', ChannelParam.PortalEmail);
        
        const nodeToId = getNodeIdFromPkidOrId(queryParams.nodeTo!);
        const dest = nodesStore.translatedNodes.find(x => x.pkid === queryParams.nodeTo!)

        const options = {
            nodeToName: dest?.name,
            logo: <img
                className="email-building-logo"
                src={buildingLogo}
                alt={building.name}
            />,
            buildingName: building.name,
            link: <a style={{wordWrap: 'break-word'}} href={linkWithEmailChannel.href}>{ linkWithEmailChannel.href }</a>,
            buildingAddress: building.address_google
        };
        return (
            <div ref = {contentRef} className="email-contenteditable">
                { convertToHtml(template, options) }
            </div>
        )
    };
    return (
        <div>
            <div className="form-group">
                <input
                    value = {emailInput}
                    onChange = {(e: any) => setEmailInput(e.target.value)}
                    className="form-control"
                    type="email"
                    placeholder="Enter your email address"
                />
            </div>
            <div>{renderEmailTemplate()}</div>
        </div>
    )
};

export default EmailContent;
